import { convertShortInfoEntry } from './common';
import { ProjectChildItemTypes, SimplifiedProjectChildItemTypes } from '../../types';
import {
  ProjectChildItemResponseTypes,
  SimplifiedProjectChildItemResponseTypes,
} from '../../types/response';
import { checkValidUrl } from '../shareLinkUtils';
import { removeUndefined } from '../formatUtils';
import { convertSimplifiedFloorResponse } from './floor';
import { VIRTUAL_TOUR_URL } from '../../commons/constants';

const getVirtualTourUrl = (
  item: SimplifiedProjectChildItemResponseTypes,
  locale?: string
): string | undefined => {
  const { virtualTourUrl, virtualTourCode } = item;
  if (!virtualTourUrl && !virtualTourCode) {
    return undefined;
  }

  const localeLanguage = locale || 'vi';
  if (virtualTourCode) {
    const url360 = `${VIRTUAL_TOUR_URL}/${localeLanguage}/tour/${virtualTourCode}`;
    return checkValidUrl(url360) ? url360 : undefined;
  }

  if (virtualTourUrl) {
    return checkValidUrl(virtualTourUrl) ? virtualTourUrl : undefined;
  }
};

export const convertSimplifiedProjectChildItemResponse = (
  item: SimplifiedProjectChildItemResponseTypes
): SimplifiedProjectChildItemTypes => {
  const convertItem: SimplifiedProjectChildItemTypes = {
    id: item.id,
    code: item.code,
    name: item.name,
    square: item.square,
    usableSquare: item.usableSquare,
    direction: item.direction,
    balconyDirections: item.balconyDirections,
    type: item.type,
    price: item.price,
    visualizeCode: item.visualizeCode,
    virtualTourUrl: item.virtualTourUrl ? item.virtualTourUrl : undefined,
    furnitureUrl: checkValidUrl(item.furnitureUrl) ? item.furnitureUrl : undefined,
    parkingNum: item.parkingNum,
    bathroom: item.bathrooms,
    bedroom: item.bedrooms,
    image: item.avatar,
    alias: item.alias,
    description: item.description,
    allowInstallment: item.allowInstallment,
    allowPet: item.allowPet,
    landUseRight: item.landUseRight,
    status: item.status,
    positionType: item.positionType,
    residenceType: item.residenceType,
    isSimplified: true,
    financeUrl: checkValidUrl(item.financeUrl) ? item.financeUrl : undefined,
    floorAlias: item.floorAlias,
    projectItemAlias: item.projectItemAlias,
    isShowSquareConfig: !!item.square, // check show data square config
    isShowDirectionConfig: !!item.direction, // check show data Direction config
    avgReviewRating: item.avgReviewRating,
  };

  if (item.floor) {
    convertItem.floor = convertSimplifiedFloorResponse(item.floor);
  }

  // remove all key with undefined value in convertItem object
  return removeUndefined(convertItem);
};

export const convertProjectChildItemResponse = (
  item: ProjectChildItemResponseTypes,
  locale?: string
): ProjectChildItemTypes => {
  const childItem = convertSimplifiedProjectChildItemResponse(item);
  const { shortInformation, introduction, information } = convertShortInfoEntry(item.shortInfo);

  const { positionType, residenceType, reviews } = item;

  return {
    ...childItem,
    visualizeCode: item.visualizeCode,
    media: item.gallery,
    positionType,
    residenceType,
    shortInformation,
    introduction,
    information,
    isSimplified: false,
    userContact: item.userContact && {
      ...item.userContact,
      userContactHomeKey: item.alias,
    },
    reviews,
    furnishingSolution: item.baseFurnishingSolution,
    similarItem: item.similarItem, // TODO update save code
    avgReviewRating: item.avgReviewRating,
    virtualTourUrl: getVirtualTourUrl(item, locale),
  };
};
